import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    user: {
        username: '',
        email: ''
    },
    modelDefault: {
        id: null,
        bot_id: null
    },
    loaded: false,
    userProfileLoaded: false,
    loadedUserToken: false,
    loadedVkGroups: false,
    vkGroups: []
}
export default {
    state,
    getters,
    actions,
    mutations
}
